module.exports = __webpack_public_path__ + "img/teams-no-tagged-users.30cd6b81.svg";